// extracted by mini-css-extract-plugin
export var columnList = "_er-0";